<template>
    <div>
        <Header4></Header4>
        <img class="banner" :src="img_url + material.pc_index_top_banner.img">
        <div class="new_detail">
            <div class="container">
                <div class="input_title" >
                    <img class="logo" alt="" :src="img_url + getClient.channel_logo" >
                    <div class="user">
                        <label>会员账号</label>
                        <input v-model="loginForm.account">
                    </div>
                    <div class="user">
                        <label>登录密码</label>
                        <input v-model="loginForm.password" type="password">
                    </div>
                    <div class="login_btn">
                        <a class=" form_btn btn_width flex_box"  @click="logining"><span>登录</span></a>
                    </div>
                </div>
            </div>
        </div>
        <Footer2></Footer2>
    </div>
</template>

<script>
import Header4 from '../components/Header4.vue'
import Footer2 from '../components/Footer2.vue'
import { mapState } from 'vuex'
import {accountLogin,getUserInformation} from '@/api/http.js'
export default {
  components: { Header4, Footer2 },
        name:'AcountLogin',
        data() {
            return {
                loginForm: {},
            }
        },
        computed:{
            ...mapState([
                'material',
                'getClient',
                'isLogin',
                'unLogin',
            ])
        },
        methods:{
          // 账号登录按钮事件
            logining() {
                accountLogin(this.loginForm).then((res) => {
                    if (res.code === 200) {
                        localStorage.setItem('inquiry_show', 1) //控制询问弹窗显示·
                        localStorage.setItem("token", res.data.token)
                        const is_auth = res.data.is_auth
                        //一定要请求一次用户信息，否则以下路由会报错
                        getUserInformation().then((res) => {
                            if (res.code === 200) {
                                localStorage.setItem('userInfo', JSON.stringify(res.data))
                                this.userInfo = res.data
                                this.unLogin = false
                                this.isLogin = true
                                // 当本地存储有userinfo后再判断实名跳转
                                if(!this.userInfo.user_mobile){
                                    this.$router.push({ path: "/member/phoneBinding" })
                                    window.location.href=window.location.href
                                }
                                else {
                                    this.$router.push({ path: "/home" })
                                    window.location.href=window.location.href
                                } 
                            }
                        }).catch((err) => {
                            //token失效时清除本都数据
                            localStorage.setItem("token", '')
                            this.$router.push({
                                path: '/home'
                            })
                            console.log('捕获异常', err)
                        })
                    }
                }).catch((err) => {
                    console.log("捕获异常", err)
                    this.bool = true
                    this.$message({
                        message: err.msg,
                        type: 'warning',
                        duration: 1500,
                    });
                })
            },
        },
        created(){
        }
    }
</script>

<style scoped>
.logo{
    width: 120px;
}
.banner{
    margin-top: 50px;
    width: 100%;
}
.new_detail{
    position: relative;
    overflow: hidden;
    top: 0;
    left: 0;
    padding: 40px 0;
    background: #fff;
}
.detail_bg{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.content_box{
    position: relative;
    z-index: 2;
    background: #FAFAFA;
    border-radius: 4px;
}

.content_bottom{
    padding: 30px;
    height: 100%;
}
.input_title{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
}
.new_content{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
    margin-top: 15px;
}
.user {
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    align-items: center;
    margin-bottom: 12px;
}

.user label {
    position: relative;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #000;
    top: 5px;
    right: 42%;
    white-space: nowrap;
}

.user input {
    margin-top: 10px;
    width: 370px;
    height: 31px;
    padding: 10px 0 10px 10px;
    background: light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4)) !important;;
    border: 1px solid #e5e6e7;
    border-radius: 4px;
    color: #000;
}

.user input:focus {
    outline-style: none;
    border: 1px solid #E0D0B4 !important;
}

.input_fgx {
    width: 1px;
    height: 35px;
    background: #645845;
    opacity: 0.4;
    z-index: 1;
    position: relative;
    left: 60px;
    top: 5px;
}
.form_btn {
    background: #f8ac59;
    border-radius: 4px;
    height: 38px;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    transition: all 0.5s;
}
.btn_width{
    width: 380px;
    margin-top: 10px;
}

.form_btn:hover {
    filter: brightness(1.2);
    color: #FFFFFF;
    transition: all 0.5s;
}

.login_btn {
    display: flex;
    justify-content: space-evenly;
}
@media (max-width:1600px) {

    .content_bottom{
        padding: 20px;
    }
    .new_content{
        font-size: 12px;
    }
}
@media (max-width: 1300px){
    .new_detail{
        margin-top: 100px;
    }
    .content_bottom{
        padding:10px 20px;
    }
}

</style>